const blogToggleMenuButton = document.querySelector("[data-blog-toggle-menu-button]");
const blogMenu = document.querySelector("[data-blog-menu]");
let newsArticle = document.querySelector(".news__article");
let blogCategoryList = document.querySelector(".blog-menu__list");
let featuredBlogPost = document.querySelector(".featured-blogpost");

function blogInit() {

	if (blogToggleMenuButton && blogMenu) {

		blogToggleMenuButton.addEventListener("click", function () {
			blogMenu.classList.toggle("is-visible");
			blogToggleMenuButton.classList.toggle("is-active");
		});
	}

	$('a.featured-blogpost, p.featured-blogpost__text__cta, .featured-blogpost h2, .featured-blogpost__image-wrapper').on("click", (e) => {
		trackFeaturedArticleClick(e);
	});

	$('a.featured-blogpost, p.featured-blogpost__text__cta, .featured-blogpost h2, .featured-blogpost__image-wrapper').on("auxclick", (e) => {
		trackFeaturedArticleClick(e);
	});

	$('.blog-overview__articles-grid a').on('click', (e) => {
		trackArticleClick(e);
	});

	$('.blog-overview__articles-grid a').on('auxclick', (e) => {
		trackArticleClick(e);
	});

	$(window).on("resize", blogCategoryHeight);

	blogCategoryHeight();

	function blogCategoryHeight() {
		if (blogCategoryList && window.matchMedia("(min-width: 480px)").matches) {
			let blogHeight = 0;
			if (featuredBlogPost) {
				$(window).on('load', function () {
					blogHeight = window.matchMedia("(min-width: 1024px)").matches ? (featuredBlogPost.clientHeight - 80) : (featuredBlogPost.clientHeight - 82);
					blogCategoryAdjust(blogHeight);
				});
			}
			if (newsArticle) {
				blogHeight = newsArticle.clientHeight - 118;
				blogCategoryAdjust(blogHeight);
			}
		}
	}

	function blogCategoryAdjust(blogHeight) {
		if (blogCategoryList.scrollHeight > blogHeight) {
			blogCategoryList.style.height = blogHeight + "px";
			blogCategoryList.style.overflowY = "scroll";
		}
	}

	function trackArticleClick(e) {
		let articleAnchor = e.target.closest('a'),
			aritcleTitle = articleAnchor.querySelector('h3').innerText.trim();

		shvenergy.tracking.trackRawEventData({
			'event': 'clickArticle',
			'articleName': aritcleTitle
		});
	}

	function trackFeaturedArticleClick(e) {
		let target = e.target,
			container = target.closest('.featured-blogpost'),
			articleName = container ? container.querySelector('h2').innerText : '';

		articleName = articleName ? articleName.trim() : '';

		shvenergy.tracking.trackRawEventData({
			'event': 'clickFeaturedArticle',
			'articleName': articleName
		});
	}
}

blogInit();